import styled from 'styled-components'

const StyledFullWidthTableContainer = styled.div`
  margin: 0 -1.5rem;
`

export default StyledFullWidthTableContainer
